import { RootState, store } from '@/app/store'
import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectSelf = (state: RootState) => state

export const authSelector = createDraftSafeSelector(selectSelf, (state) => state.auth)

/**
 * A session that may drive automatic API traffic. A session that still owes strong-MFA setup is
 * NOT fully authenticated: every non-2FA call would 428 (and, for some roles, 403), so nothing
 * should fetch on its behalf until the requirement clears. Mount-time fetches gate on this, never
 * on `token` alone.
 */
export const isFullyAuthenticatedSelector = createDraftSafeSelector(
  authSelector,
  (auth) => !!auth.token && !auth.strongMfaSetupRequired
)

export const getAuthInfo = () => {
  return store.getState().auth
}
